// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"287e6af5","269":"6b5e5f8f","453":"95da9d45","950":"23b59c61"}[chunkId] + ".chunk.js";
};